import { Checkbox, FormControlLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import Changes from "../../common/Changes";
import Loader from "../../common/loader/Loader";
import { moveFormatter } from "../../fomatters/BooleanFormatter";

export default forwardRef(function ProfileInfo(props, ref) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },
    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "75%",
      "& .MuiTextField-root": {
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const [loading, setLoading] = useState(true);
  const [profileTeasers, setProfileTeaser] = useState([]);
  const [selectedTeaserProfile, setSelectedTeaserProfile] = useState(0);

  const onAfterDeleteRow = (ids, rows) =>
    Promise.all(
      ids.map((id, index) =>
        axios.post(
          `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileCustomTeaser_Delete`,
          {
            IdProfile: props.Profile.IdProfile,
            IdWagerType: rows[index].IdWagerType,
            IdUser: userInfo.userId,
          }
        )
      )
    ).then(() => requestTeasers());

  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
    },
    afterInsertRow: onAfterInsertRow,
    afterDeleteRow: onAfterDeleteRow,
  };

  function onAfterInsertRow(row) {
    let Request = {
      IdProfile: props.Profile.IdProfile,
      Enabled: true,
      Name: row.Name,
      TeaserSize: row.TeaserSize,
      Odds: row.Odds,
      BuyHalf: row.BuyHalf,
      Buy1: row.Buy1,
      Tie: row.Tie,
      TieId: row.TieId ?? 0,
      NFLSide: row.NFLSide,
      NFLTotal: row.NFLTotal,
      NBASide: row.NBASide,
      NBATotal: row.NBATotal,
      CFBSide: row.CFBSide,
      CFBTotal: row.CFBTotal,
      CBBSide: row.CBBSide,
      CBBTotal: row.CBBTotal,
      MaxSide: row.MaxSide,
      MaxTotal: row.MaxTotal,
      DropHalfPoint: row.DropHalfPoint === "true",
      Special: true,
      Cancel: row.Cancel === "true",
      WaitForDetails: true,
      MaxOpenSpots: row.MaxOpenSpots,
      MaxRisk: row.MaxRisk,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/Profile/PlayerProfileCustomTeaser_Insert",
      data: Request,
    }).then((response) => {
      if (response.data === "0") {
        alert("Data Successfully Updated");
      }
      console.log("response", response);
    });
  }

  const getOptionsForTeaser = (teaserName) => {
    const baseOptions = ["WINS", "LOSES", "NO BET", "NOT BET REGARDLESS"];
    const demoteOptions = [];

    const match = teaserName.match(/^(\d+) TEAM TEASERS$/i);
    if (match) {
      const teamNumber = parseInt(match[1], 10);
      if (teamNumber > 2) {
        demoteOptions.push(`DEMOTE TO ${teamNumber - 1} TEAM TEASERS`);
      }
    }

    return baseOptions.concat(demoteOptions);
  };

  const requestTeasers = () => {
    setLoading(true);
    const url =
      process.env.REACT_APP_API2_URL +
      "/Profile/PlayerProfileCustomTeaser_GetInfo" +
      "?IdProfile=" +
      props.Profile.IdProfile;
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let mappedArr = data.map((x) => ({
          IdProfile: x.idProfile ?? x["IdProfile"],
          IdWagerType: x.idWagerType ?? x["IdWagerType"],
          Name: x.name ?? x["Name"],
          Enabled: x.enabled ?? x["Enabled"],
          TeaserSize: x.teaserSize ?? x["TeaserSize"],
          Odds: x.odds ?? x["Odds"],
          BuyHalf: x.buyHalf ?? x["BuyHalf"],
          Buy1: x.buy1 ?? x["Buy1"],
          Tie: x.tie ?? x["Tie"],
          TieId: x.tieId ?? x["TieId"],
          NFLSide: x.nflSide ?? x["NFLSide"],
          NFLTotal: x.nflTotal ?? x["NFLTotal"],
          NBASide: x.nbaSide ?? x["NBASide"],
          NBATotal: x.nbaTotal ?? x["NBATotal"],
          CFBSide: x.cfbSide ?? x["CFBSide"],
          CFBTotal: x.cfbTotal ?? x["CFBTotal"],
          CBBSide: x.cbbSide ?? x["CBBSide"],
          CBBTotal: x.cbbTotal ?? x["CBBTotal"],
          MaxSide: x.maxSide ?? x["MaxSide"],
          MaxTotal: x.maxTotal ?? x["MaxTotal"],
          DropHalfPoint: x.dropHalfPoint ?? x["DropHalfPoint"],
          Special: x.special ?? x["Special"],
          Cancel: x.cancel ?? x["Cancel"],
          WaitForDetails: x.waitForDetails ?? x["WaitForDetails"],
          MaxOpenSpots: x.maxOpenSpots ?? x["MaxOpenSpots"],
          LastModification: x.lastModification ?? x["LastModification"],
          LastModificationUser: x.lastModificationUser ?? x["LastModificationUser"],
          MaxRisk: x.maxRisk ?? x["MaxRisk"],
          Demotes: [x.tie ?? x["Tie"], "Wins", "Loses", "No Bet", "No Bet Regardless"],
        }));
        setProfileTeaser(mappedArr);
        setLoading(false);
      });
  };

  useEffect(() => {
    requestTeasers();
  }, []);

  useEffect(() => {
    requestTeasers();
  }, [props.Profile.IdProfile]);

  const cellEditProp = {
    mode: "click",
    blurToSave: true,
    afterSaveCell: onAfterSaveCell,
  };

  const changedIndexRef = useRef(new Set());

  function onAfterSaveCell(row, cellName, cellValue, { rowIndex }) {
    changedIndexRef.current.add(rowIndex);
    profileTeasers[rowIndex] = row;
    setProfileTeaser([...profileTeasers]);
  }

  const updateTeaser = () => {
    Promise.all(
      Array.from(changedIndexRef.current).map((index) => {
        const data = {
          ...profileTeasers[index],
          IdUser: userInfo.userId,
        };
        return axios({
          method: "post",
          url:
            process.env.REACT_APP_API2_URL +
            "/Profile/PlayerProfileCustomTeaser_Update",
          data,
        });
      })
    ).then(() => requestTeasers());
  };

  useImperativeHandle(ref, () => ({
    updateTeaser,
  }));
  const handleTPRowSelect = (row) => {
    setSelectedTeaserProfile(row.IdWagerType);
  };

  const selectRowProp = {
    mode: "radio", // 'checkbox' for multiple selection, 'radio' for single selection
    selected: [selectedTeaserProfile],
    onSelect: handleTPRowSelect,
  };

  const [localProfile, setLocalProfile] = useState(props.Profile);
  const handleChange = (event, key, value) => {
    props.Profile[key] = event ? event.target.value : value;
    setLocalProfile({
      ...localProfile,
      [key]: event ? event.target.value : value,
    });
  };

  useEffect(() => {
    setLocalProfile({
      ...props.Profile,
    });
  }, [props.Profile, setLocalProfile]);

  if (loading) return <Loader />;
  return (
    <div className="flex flex-col gap-4 h-max">
      <h3>Profile Teaser</h3>

      {profileTeasers && (
        <>
          <BootstrapTable
            className="w-full overflow-hidden table-responsive"
            data={profileTeasers}
            cellEdit={cellEditProp}
            options={options}
            insertRow={true}
            selectRow={selectRowProp}
            deleteRow
          >
            <TableHeaderColumn
              visible="none"
              isKey={true}
              hidden
              autoValue
              hiddenOnInsert
              dataField="IdWagerType"
            >
              ID
            </TableHeaderColumn>

            <TableHeaderColumn dataField="Name" editable={() => false}>
              Name
            </TableHeaderColumn>
            <TableHeaderColumn dataField="TeaserSize" editable={() => false}>
              Size
            </TableHeaderColumn>
            <TableHeaderColumn dataField="NFLSide">
              NFL Side Base
            </TableHeaderColumn>
            <TableHeaderColumn dataField="NFLTotal">
              NFL Total Base
            </TableHeaderColumn>
            <TableHeaderColumn dataField="NBASide">
              NBA Side Base
            </TableHeaderColumn>
            <TableHeaderColumn dataField="NBATotal">
              NBA Total Base
            </TableHeaderColumn>
            <TableHeaderColumn dataField="CFBSide">
              CFB Side Base
            </TableHeaderColumn>
            <TableHeaderColumn dataField="CFBTotal">
              CFB Total Base
            </TableHeaderColumn>
            <TableHeaderColumn dataField="CBBSide">
              CBB Side Base
            </TableHeaderColumn>
            <TableHeaderColumn dataField="CBBTotal">
              CBB Total Base
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="DropHalfPoint"
              dataFormat={moveFormatter}
              editable={{
                type: "checkbox",
                options: {
                  values: "true:false",
                },
              }}
            >
              Drop Half Point
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="Cancel"
              dataFormat={moveFormatter}
              editable={{
                type: "checkbox",
                options: {
                  values: "true:false",
                },
              }}
            >
              Cancel
            </TableHeaderColumn>
            <TableHeaderColumn dataField="MaxSide">Max Sides</TableHeaderColumn>
            <TableHeaderColumn dataField="MaxTotal">
              Max Total
            </TableHeaderColumn>
            <TableHeaderColumn dataField="MaxOpenSpots">
              Max Open Spots
            </TableHeaderColumn>
            <TableHeaderColumn dataField="MaxRisk">Max Risk</TableHeaderColumn>
            <TableHeaderColumn dataField="Odds">Odds</TableHeaderColumn>
            <TableHeaderColumn dataField="BuyHalf">Buy ½</TableHeaderColumn>
            <TableHeaderColumn dataField="Buy1">Buy +1</TableHeaderColumn>

            <TableHeaderColumn
              dataField="Tie"
              editable={(cell, row) => ({
                type: "select",
                options: {
                  values: getOptionsForTeaser(row.Name),
                },
              })}
            >
              Tie
            </TableHeaderColumn>
          </BootstrapTable>

          <div className="flex-1 col-span-1 horizontal-options !gap-0">
            <Changes
              title={`Changes`}
              buttonText={"Changes"}
              params={{
                ChangeType: 18,
                IdSport: "",
                Param1: props.Profile.IdProfile,
                Param2: selectedTeaserProfile,
                Param3: -1,
              }}
            />
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localProfile.tL_OpenLose}
                  onChange={(event) => {
                    handleChange(
                      undefined,
                      "tL_OpenLose",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Open Spot + Lose = Lose (Using NO BET REGARDLESS)"
            />
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localProfile.tL_TeaserCancel}
                  onChange={(event) => {
                    handleChange(
                      undefined,
                      "tL_TeaserCancel",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="NO BET when a game is cancelled"
            />
          </div>
        </>
      )}
    </div>
  );
});
